// extracted by mini-css-extract-plugin
export default {"globalTable":"Table_globalTable__LwF7V","tableHead":"Table_tableHead__e0ney","tableBody":"Table_tableBody__AHGSm"};